module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Breadcrumbs":{"separator":"&sol;"}},"en":{"Breadcrumbs":{"separator":"&sol;"}}}')
  delete Component.options._Ctor
}
